import React, { useEffect } from "react";
import { commonServices } from "../../../../api/services/commonServices";
import { useAppSelector } from "../../../../infra/hooks";

interface MyTeamDTOProps {
  setAllDepartments: (departments: []) => void;
  setAllEmployeeTypes: (employeeTypes: []) => void;
  setAllContractTypes: (contractTypes: []) => void;
  setAllEmployeeCategory: (empCategory: []) => void;
  setAllPayrollTypes: (payrollTypes: []) => void;
}
function DTOJobInfoUpdateModal({
  setAllDepartments,
  setAllEmployeeTypes,
  setAllContractTypes,
  setAllEmployeeCategory,
  setAllPayrollTypes,
}: MyTeamDTOProps) {
  const companyId = useAppSelector((state) => state.authSlice.company_id);

  async function getAllDepartment() {
    const response = await commonServices.getAllCompanyDepartments(companyId);
    if (response) {
      const { data }: any = response;
      setAllDepartments(data);
    }
  }
  async function getAllEmployeeTypes() {
    const response = await commonServices.getCompanyEmployeeTypes(companyId);
    if (response) {
      const { data }: any = response;
      setAllEmployeeTypes(data);
    }
  }
  async function getAllContractTypes() {
    const response = await commonServices.getCompanyContractTypes(companyId);
    if (response) {
      const { data }: any = response;
      setAllContractTypes(data);
    }
  }
  async function getAllEmployeeCategory() {
    const response = await commonServices.getCompanyEmployeeCategories(
      companyId
    );
    if (response) {
      const { data }: any = response;
      setAllEmployeeCategory(data);
    }
  }
  async function getAllPayrollTypes() {
    const response = await commonServices.getCompanyPayrollTypes(companyId);
    if (response) {
      const { data }: any = response;
      setAllPayrollTypes(data);
    }
  }

  useEffect(() => {
    getAllDepartment();
    getAllContractTypes();
    getAllEmployeeCategory();
    getAllPayrollTypes();
    getAllEmployeeTypes();
  }, []);

  return <></>;
}
export default DTOJobInfoUpdateModal;
